/*
 * @param: hex { string} 例如:"#23ff45"
 * @param: opacity  { string || number } 透明度
 * @return: { string } rgba格式
 */
export function hexToRgba(hex, opacity) {
	if (String(opacity) != '0' && !opacity) opacity = 1;
	return "rgba(" + parseInt("0x" + hex.slice(1, 3)) + "," + parseInt("0x" + hex.slice(3, 5)) + "," + parseInt("0x" +
		hex.slice(5, 7)) + "," + opacity + ")"
}
export function toHex(r, g, b) {
	const INT_HEX_MAP = {
		10: 'A',
		11: 'B',
		12: 'C',
		13: 'D',
		14: 'E',
		15: 'F'
	};
	const hexOne = function(value) {
		value = Math.min(Math.round(value), 255);
		const high = Math.floor(value / 16);
		const low = value % 16;
		return '' + (INT_HEX_MAP[high] || high) + (INT_HEX_MAP[low] || low); // 转换核心
	};
	if (isNaN(r) || isNaN(g) || isNaN(b)) return '';
	return '#' + hexOne(r) + hexOne(g) + hexOne(b);
}
export function changeOpacity(str,opacity){
	let colornum = [];
	if (String(str).indexOf('#') > -1) {
		str = hexToRgba(str, opacity);
		// console.log('before'+str)
		colornum = String(str).match(/\d*(\d|[0.]\d)/g);
	} else if(String(str).split(',').length >= 3){
		colornum = String(str).match(/\d*(\d|[0.]\d)/g);
	}else
		return 'error';
	if (colornum.length < 3) return 'error';
	if (colornum.length > 3 && colornum[3] > 1 && colornum[3] < 0) return 'error';
	if(colornum.length > 3) colornum[3]=Number(opacity);
	else colornum.push(Number(opacity));
	str = colornum.join(',')
	return `rgba(${str})`;
}
export function getSampleColor(str,offset){
	let colornum = [];
	if (String(str).indexOf('#') > -1) {
		str = hexToRgba(str, 1);
		// console.log('before'+str)
		colornum = String(str).match(/\d*(\d|[0.]\d)/g);
	} else if (String(str).split(',').length >= 3) { //String(str).indexOf('rgb')>-1&&
		colornum = String(str).match(/\d*(\d|[0.]\d)/g);
		if (colornum.length < 3) return 'error';
		if (colornum.length > 3 && colornum[3] > 1 && colornum[3] < 0) return 'error';
		for (let i = 0; i <= 2; i++) {
			if (colornum[i] > 255) return 'error';
		}
	} else return 'error';
	var index=0;
	var max=0;
	for(let i=0;i<=2;i++){
		if(Number(colornum[i])>max){
			index=i;
			max=Number(colornum[i]);
		}
	}
	console.log(max,index,colornum[index],colornum)
	if(!offset) offset=70;
	if(Number(colornum[index])+offset>255) colornum[index]=255;
	else colornum[index]=Number(colornum[index])+Number(offset) ;
	str = colornum.join(',')
	return `rgba(${str})`;
}
export function getColor(str, opacity,offset) {
	let colornum = [];
	if (String(str).indexOf('#') > -1) {
		str = hexToRgba(str, opacity);
		// console.log('before'+str)
		colornum = String(str).match(/\d*(\d|[0.]\d)/g);
	} else if (String(str).split(',').length >= 3) { //String(str).indexOf('rgb')>-1&&
		colornum = String(str).match(/\d*(\d|[0.]\d)/g);
		if (colornum.length < 3) return 'error';
		if (colornum.length > 3 && colornum[3] > 1 && colornum[3] < 0) return 'error';
		for (let i = 0; i <= 2; i++) {
			if (colornum[i] > 255) return 'error';
		}
	} else return 'error';
	if (String(opacity) != '0' && !opacity) opacity = 1;
	for(let i=0;i<=2;i++){
		let num=Number(colornum[i]);
		if(offset){
			if(num>0)
				num=num+Number(offset);
		}
		else if(num<200&&num>100){
			num=num+100;
		}else if(num<=100&&num>0) num=num+140;
		else if(num==0) num=num+200;
		if(num>255) colornum[i]=String(255);
		else colornum[i]=String(num);
	}
	str = colornum.join(',')
	// console.log('after'+str)
	return `rgba(${str})`;
}
